export const PRIVACY_POLICY_VERSION = "2026-10-05";

export const fieldClass =
  "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5";

export interface BillingFields {
  salutation: string;
  company: string;
  street: string;
  postal_code: string;
  city: string;
  country: string;
  vat_id: string;
  billing_email: string;
  project_count: string;
  message: string;
}

export const emptyBilling = (): BillingFields => ({
  salutation: "",
  company: "",
  street: "",
  postal_code: "",
  city: "",
  country: "",
  vat_id: "",
  billing_email: "",
  project_count: "1",
  message: "",
});

export function billingFieldsFromProfile(
  row:
    | (Partial<Omit<BillingFields, "project_count">> & {
        project_count?: number | string;
      })
    | null
    | undefined
): BillingFields {
  if (!row) {
    return emptyBilling();
  }
  const count = Number(row.project_count);
  return {
    salutation: row.salutation || "",
    company: row.company || "",
    street: row.street || "",
    postal_code: row.postal_code || "",
    city: row.city || "",
    country: row.country || "",
    vat_id: row.vat_id || "",
    billing_email: row.billing_email || "",
    project_count: Number.isFinite(count) && count >= 1 ? String(count) : "1",
    message: row.message || "",
  };
}
